import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";

import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../services/SellingService";
import DataTableProductsSale from "../../ui/DataTableProductsSale";
import withLoader from "../../components/layouts/WithLoader";
import UtilsFormule from "../../utils/UtilsFormule";
const fmt = (v) => (v != null ? parseFloat(Number(v).toFixed(3)) : "");

const ProductsBySaleDocument = ({ startLoading, stopLoading }) => {
  const params = useParams();
  const [documentProducts, setDocumentProducts] = useState([]);
  const [refrech, setRefrech] = useState(false);

  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [bdcImageFile, setBdcImageFile] = useState([]);
  const [bdcLanguage, setBdcLanguage] = useState("fr");
  const [bdcGenerating, setBdcGenerating] = useState(false);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
 
      if (localStorage.getItem("status") == null) {
        setUserRole(["notConnected"]);
      } else {
        setUserRole(JSON.parse(localStorage.getItem("status")));
      }

    if (sessionStorage.getItem("typeDocument") === "devis") {
      startLoading()

      SellingService.getDevisByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          console.log("response", response.data.success);
          setDocumentProducts(response.data.success);
        })
        .catch((e) => {
          alert("error",e);
        }).finally(()=>{
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "bdc") {
      startLoading()

      SellingService.getBDCByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          setDocumentProducts(response.data.success);
        })
        .catch((e) => {
          alert("error",e);
        }).finally(()=>{
          stopLoading()
        });
    } else if (sessionStorage.getItem("typeDocument") === "facture") {
      startLoading()

      SellingService.getFactureByRef(
        sessionStorage.getItem("refDocument"),
        getCurrentUserId()
      )
        .then((response) => {
          setDocumentProducts(response.data.success);
        })
        .catch((e) => {
          alert("error",e);
        }).finally(()=>{
          stopLoading()
        });
    }
    
  }, [refrech]);
  
  // the language of the file to generate starts at the language of the order
  useEffect(() => {
    if (documentProducts && documentProducts.language) {
      setBdcLanguage(documentProducts.language);
    }
  }, [documentProducts]);

  // opened right after a save ("Enregistrer et imprimer"): print once the document is loaded
  useEffect(() => {
    const wantsPrint = new URLSearchParams(window.location.search).get("print") === "1";
    if (wantsPrint && documentProducts && !Array.isArray(documentProducts)) {
      const t = setTimeout(() => window.print(), 600);
      return () => clearTimeout(t);
    }
  }, [documentProducts]);

  // le nom du client n'a pas le même champ selon le type de document
  const clientName =
    documentProducts?.clientTitle ||
    documentProducts?.client?.title ||
    documentProducts?.clientName ||
    documentProducts?.client?.name ||
    "-";

  const onValidateDevisHandler = (ref) => {
    sessionStorage.setItem("refDevis", ref);
    // sessionStorage.setItem("typeToTax", "Devis");
    navigate("/validateDevisBDCVente");
  };
  const onValidateBDCHandler = (ref) => {
    sessionStorage.setItem("refBDC", ref);
    // sessionStorage.setItem("typeToTax", "Devis");
    navigate("/validateBDCFactureVente");
  };

  const onRecieveBDCHandler = (ref) => {
    sessionStorage.setItem("refBDC", ref);
    navigate("/sendAllProducts");
  };

  // function buttonFileFormatter(cell, row) {
  //   if (row.path !== "any" && row.path !== null && row.path !== "string") {
  //     return (
  //       <button
  //         style={{ width: 40 }}
  //         class="btn bg-gray btn-sm "
  //         onClick={() =>
  //           onShowFileInOtherWizndowHandler(
  //             // UtilsUrl.sellingFileURL() +
  //             row.path
  //           )
  //         }
  //       >
  //         <i class="fas fa-eye"></i>
  //       </button>
  //     );
  //   } else {
  //     return (
  //       <span>
  //         <button
  //           style={{ width: 40 }}
  //           class="btn bg-gray btn-sm text-center"
  //           onClick={() =>
  //             onUploadFileHandler(row.state, row.reference, row.isDeleted)
  //           }
  //         >
  //           <i class="fas fa-plus"></i>
  //         </button>
  //       </span>
  //     );
  //   }
  // }

  const onUploadFileHandler = (reference) => {
    startLoading();
    SellingService.generateFacture(getCurrentUserId(), reference).then(
      (response) => {
        console.log("response", response);
        onShowFileInOtherWizndowHandler(response.data?.facture?.path);
      }
    ).finally(()=>{
      stopLoading();
      // window.location.reload(true);
    });
  };
  const onUploadFileDevisHandler = (state, reference, isDeleted) => {
    startLoading();

    SellingService.generateDevis(getCurrentUserId(), reference).then(
      (response) => {
        console.log("response", response);
        onShowFileInOtherWizndowHandler(response.data?.devis?.path);
        // window.location.reload(true);

      }
    ).finally(()=>{
      stopLoading();
    });
  };

  const onGenerateBdcHandler = () => {
    if (bdcGenerating) return;
    setBdcGenerating(true);
    startLoading();
    SellingService.generateBDC(getCurrentUserId(), documentProducts.reference, bdcLanguage)
      .then((response) => {
        const path = response.data && response.data.path;
        if (path) {
          setDocumentProducts({ ...documentProducts, path, language: bdcLanguage });
          onShowFileInOtherWizndowHandler(path);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : le bon de commande n'a pas pu être généré");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il y a un problème de connexion");
      })
      .finally(() => {
        setBdcGenerating(false);
        stopLoading();
      });
  };
  const factureFile = () => {
    if (
      sessionStorage.getItem("typeDocument") === "facture" &&
      documentProducts.path === "any" 
    ) {
      return (
        <section className="content-header">
          <div className="container-fluid">
            <div class="card card-dark">
              <div class="card-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div class="form-group">
                      <label for="exampleInputFile">Facture: {documentProducts.ref} </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div className="row">
                  <div className="col-sm-9"></div>
                  <div className="col-sm-3">
                    <button
                      class="btn btn-dark btn-sm float-right"

                      onClick={(event) =>
                        onUploadFileHandler( documentProducts.ref)
                       
                      }
                     
                    >
                      Générer document
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else if (
      sessionStorage.getItem("typeDocument") === "facture" &&
      documentProducts.path !== "any"
    ){
      return (
        <section className="content-header">
          <div className="container-fluid">
            <section className="content-header">
              <div className="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-md-10">
                        <h5 class="card-title">
                          Facture: {documentProducts.ref}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <button
                          style={{ width: 40 }}
                          class="btn bg-gray btn-sm "
                          onClick={() => onShowFileInOtherWizndowHandler(
                            documentProducts.path
                          )}
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      );
    }
  };
  
  const onUploadFileToBackendHandler = () => {
    if (bdcImageFile.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :aucun fichier ");
    } else {
      // console.log(devisUploadInformation);
      const uploadData = new FormData();
      uploadData.append("picture", bdcImageFile);

      SellingService.uploadFile("/uploadFile/BonCommandeSale", uploadData)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          SellingService.updateBDCPathFile(getCurrentUserId(), documentProducts.reference, response.data.success)
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              setBdcImageFile([]);
              setRefrech((value) => !value);
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur  ");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur : erreur lors de l'enregistrment du fichier"
            );
          });
    

        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur : erreur lors de l'enregistrment du fichier"
        );
      });

    }
  };
  const BDCFile = () => {
    if (sessionStorage.getItem("typeDocument") !== "bdc") return null;
    const hasFile =
      documentProducts.path &&
      documentProducts.path !== "any" &&
      documentProducts.path !== "string" &&
      documentProducts.path !== "String";
    return (
      <section className="content-header no-print">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-file-pdf mr-2"></i>
                Fichier du bon de commande {documentProducts.reference}
              </h3>
            </div>
            <div className="card-body">
              <div className="row align-items-end">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="bdcLanguage">Langue du fichier</label>
                    <select
                      id="bdcLanguage"
                      className="form-control"
                      value={bdcLanguage}
                      onChange={(e) => setBdcLanguage(e.target.value)}
                    >
                      <option value="fr">Français</option>
                      <option value="en">English</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-dark mr-2"
                      disabled={bdcGenerating}
                      onClick={onGenerateBdcHandler}
                    >
                      <i className="fas fa-cogs mr-1"></i>
                      {hasFile ? "Régénérer le bon de commande" : "Générer le bon de commande"}
                    </button>
                    {hasFile && (
                      <button
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={() => onShowFileInOtherWizndowHandler(documentProducts.path)}
                      >
                        <i className="fas fa-eye mr-1"></i>Voir le fichier
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <small className="text-muted">
                {hasFile
                  ? "Un fichier existe déjà : le régénérer le remplace, dans la langue choisie."
                  : "Aucun fichier pour ce bon de commande. Le fichier généré suit la langue choisie (libellés, noms et descriptions des produits)."}
              </small>
              <hr />
              <div className="form-group mb-0">
                <label htmlFor="bdcOwnFile">Ou ajouter votre propre fichier</label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      accept="application/pdf, .jpg, .jpeg, .png"
                      type="file"
                      className="custom-file-input"
                      id="bdcOwnFile"
                      onChange={(e) => setBdcImageFile((e.target.files && e.target.files[0]) || [])}
                    />
                    <label className="custom-file-label" htmlFor="bdcOwnFile">
                      {bdcImageFile && bdcImageFile.name ? bdcImageFile.name : "Choisir un fichier (PDF ou image)"}
                    </label>
                  </div>
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      disabled={!bdcImageFile || bdcImageFile.length === 0}
                      onClick={onUploadFileToBackendHandler}
                    >
                      Ajouter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const devisFile = () => {
    if (
      sessionStorage.getItem("typeDocument") === "devis" &&
      (documentProducts.path === "any" ||
        documentProducts.path === null ||
        documentProducts.path === undefined)
    ) {
      return (
        <section className="content-header">
          <div className="container-fluid">
            <div class="card card-dark">
              <div class="card-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div class="form-group">
                      <label for="exampleInputFile">Devis : {documentProducts.reference}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div className="row">
                  <div className="col-sm-9"></div>
                  <div className="col-sm-3">
                    <button
                      class="btn btn-dark btn-sm float-right"
                      onClick={ ()=> onUploadFileDevisHandler(documentProducts.state, documentProducts.reference, documentProducts.isDeleted)
                     }
                    >
                      Générer document
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return (
        <section className="content-header">
          <div className="container-fluid">
            <section className="content-header">
              <div className="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-md-10">
                        <h5 class="card-title">
                          Devis: {documentProducts.reference}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <button
                          style={{ width: 40 }}
                          class="btn bg-gray btn-sm "
                          onClick={(event) =>
                            onShowFileInOtherWizndowHandler(
                              documentProducts.path
                            )                           
                          }
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      );
    }
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+error);
      });
  };
  return (
    <div className="content-wrapper document-details" style={{ marginTop: "0" }}>
      <style>{`
        @media print {
          .main-sidebar, .main-header, .main-footer, .no-print { display: none !important; }
          .content-wrapper { margin-left: 0 !important; }
        }
        .document-details .card.card-dark {
          background: #fff;
          border-radius: 8px;
          border-top: 3px solid #343a40;
          box-shadow: 0 1px 6px rgba(0,0,0,.08);
        }
        .document-details .card.card-dark .card-title {
          font-weight: 600;
          color: #343a40;
        }
        .document-details .card.card-dark .card-header {
          background: #fff;
          color: #343a40;
        }
        .document-details .info-box {
          background: #fff !important;
          color: #343a40 !important;
          border-radius: 8px;
          border-left: 4px solid #343a40;
          box-shadow: 0 1px 6px rgba(0,0,0,.08);
        }
        .document-details .info-box .info-box-icon {
          background: #343a40 !important;
          color: #fff !important;
          border-radius: 8px;
          margin: 8px 0 8px 8px;
          min-height: 54px;
          height: 54px;
          width: 54px;
        }
        .document-details .info-box .info-box-text {
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #6c757d !important;
        }
        .document-details .info-box .info-box-number {
          font-size: 1.15rem;
          font-weight: 700;
          color: #343a40 !important;
        }
        .document-details .info-box .progress {
          display: none;
        }
        .document-details .info-box .progress-description {
          color: #6c757d !important;
          font-size: 0.8rem;
        }
      `}</style>
      <section className="content-header">
        <div className="container-fluid">
          {sessionStorage.getItem("typeDocument") === "devis" && (
            <>
            <section className="content-header">
                <div className="container-fluid">
                  <div class="card card-dark">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-10">
                          <h5 class="card-title">
                            Devis: {documentProducts.reference}
                          </h5>
                        </div>
                        <div className="col-md-2">
                          {" "}
                          <i class="fa-regular fa-calendar-days"></i> Date:{" "}
                          {documentProducts.creationDate}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="row">
              <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Client</span>
                      <span className="info-box-number">
                        {clientName}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-dollar-sign"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix TTC</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.ttPrice)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {fmt(documentProducts.htPrice)} DNT prix HT
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-chart-line"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix de vente</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.buyingPrice)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {documentProducts.discountPercentage !== 0 && (
                        <span className="progress-description">
                          Promotion de{documentProducts.discountPercentage}%{" "}
                        </span>
                      )}
                      {documentProducts.discountPercentage === 0 && (
                        <span className="progress-description">
                          {fmt(documentProducts.htPrice)} DNT prix HT
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box  bg-black">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produits</span>

                      {documentProducts.sales && (
                        <span className="info-box-number">
                          {documentProducts.sales.length}{" "}
                        </span>
                      )}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      {documentProducts.sales && (
                        <span className="progress-description">
                          {documentProducts.sales.length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {devisFile()}
              {/* <div className="row">
                <div className="col-md-10 col-sm-6 col-12"></div>
                <div className="col-md-2 col-sm-6 col-12">
                  {" "}
                  <button 
                  disabled={userRole.includes("COMMERCIAL")}
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onValidateDevisHandler(
                        sessionStorage.getItem("refDocument")
                      )
                    }
                  >
                    <i class="fas fa-check"></i>
                    Bon de commande
                  </button>
                </div>
              </div> */}
            </>
          )}
          {sessionStorage.getItem("typeDocument") === "bdc" && (
            <>
            <section className="content-header">
                <div className="container-fluid">
                  <div class="card card-dark">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-10">
                          <h5 class="card-title">
                            Bon de commande: {documentProducts.reference}
                          </h5>
                        </div>
                        <div className="col-md-2">
                          {" "}
                          <i class="fa-regular fa-calendar-days"></i> Date:{" "}
                          {documentProducts.creationDate}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="row">
              <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Client</span>
                      <span className="info-box-number">
                        {clientName}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-dollar-sign"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix TTC</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.ttPrice)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {fmt(documentProducts.htPrice)} DNT prix HT
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-chart-line"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix de vente</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.buyingPrice)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {documentProducts.discountPercentage !== 0 && (
                        <span className="progress-description">
                          Promotion de{documentProducts.discountPercentage}%{" "}
                        </span>
                      )}
                      {documentProducts.discountPercentage === 0 && (
                        <span className="progress-description">
                          {fmt(documentProducts.htPrice)} DNT prix HT
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box  bg-black">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produits</span>

                      {documentProducts.sales && (
                        <span className="info-box-number">
                          {documentProducts.sales.length}{" "}
                        </span>
                      )}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      {documentProducts.sales && (
                        <span className="progress-description">
                          {documentProducts.sales.length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-9 col-sm-6 col-12"></div>
                <div className="col-md-1 col-sm-6 col-12"></div>
                <div className="col-md-2 col-sm-6 col-12">
                  <button
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onRecieveBDCHandler(sessionStorage.getItem("refDocument"))
                    }
                  >
                    <i class="fas fa-check"></i>
                    Envoyer tous les produits
                  </button>
                </div>
                {/* <div className="col-md-1 col-sm-6 col-12">
                  <button
                    class="btn btn-dark btn-sm float-right"
                    onClick={() =>
                      onValidateBDCHandler(
                        sessionStorage.getItem("refDocument")
                      )
                    }
                  >
                    <i class="fas fa-check"></i>
                    Facture
                  </button>
                </div> */}
              </div>

              {BDCFile()}

            </>
          )}
          {sessionStorage.getItem("typeDocument") === "facture" && (
            <>
              <section className="content-header">
                <div className="container-fluid">
                  <div class="card card-dark">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-10">
                          <h5 class="card-title">
                            Facture: {documentProducts.ref}
                          </h5>
                        </div>
                        <div className="col-md-2">
                          {" "}
                          <i class="fa-regular fa-calendar-days"></i> Date:{" "}
                          {UtilsFormule.formatDate(documentProducts.createionDate)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="row">
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-user"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Client</span>
                      <span className="info-box-number">
                        {clientName}
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-dollar-sign"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix TTC</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.priceTT)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {fmt(documentProducts.sellingPrice)} DNT prix HT
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark ">
                    <span className="info-box-icon">
                      <i class="fas fa-chart-line"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Prix de vente</span>
                      <span className="info-box-number">
                        {fmt(documentProducts.sellingPrice)} DNT
                      </span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "70%" }}
                        />
                      </div>
                      {documentProducts.discountPercentage !== 0 && (
                        <span className="progress-description">
                          Promotion de{documentProducts.discountPercentage}%{" "}
                        </span>
                      )}
                      {documentProducts.discountPercentage === 0 && (
                        <span className="progress-description">
                          {fmt(documentProducts.sellingPrice)} DNT prix HT
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 col-12">
                  <div className="info-box  bg-black">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produits</span>

                      {documentProducts.sales && (
                        <span className="info-box-number">
                          {documentProducts.sales.length}{" "}
                        </span>
                      )}
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      {documentProducts.sales && (
                        <span className="progress-description">
                          {documentProducts.sales.length}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {factureFile()}
             
            </>
          )}
          {sessionStorage.getItem("typeDocument") === "po" && (
            <div className="row">
              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box bg-gray ">
                  <span className="info-box-icon">
                    <i class="fas fa-dollar-sign"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Prix TTC</span>
                    <span className="info-box-number">
                      {fmt(documentProducts.ttPrice)} DNT
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>
                    <span className="progress-description">
                      {fmt(documentProducts.buyingPrice)} DNT prix HT
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box bg-gray-dark ">
                  <span className="info-box-icon">
                    <i class="fas fa-chart-line"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Prix de vente</span>
                    <span className="info-box-number">
                      {fmt(documentProducts.buyingPrice)} DNT
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>
                    {documentProducts.discountPercentage !== 0 && (
                      <span className="progress-description">
                        Promotion de{documentProducts.discountPercentage}%{" "}
                      </span>
                    )}
                    {documentProducts.discountPercentage === 0 && (
                      <span className="progress-description">
                        {fmt(documentProducts.buyingPrice)} DNT prix HT
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 col-12">
                <div className="info-box  bg-black">
                  <span className="info-box-icon">
                    <i class="fas fa-shopping-cart"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Produits</span>

                    {documentProducts.sales && (
                      <span className="info-box-number">
                        {documentProducts.sales.length}{" "}
                      </span>
                    )}
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>
                    {documentProducts.sales && (
                      <span className="progress-description">
                        {documentProducts.sales.length}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <br />

          {params.type === "po" && (
            <h5 class="card-title">
              Les produits associés à l'operation d'achat:
              <span> {params.refDocument} </span>
            </h5>
          )}

          {params.type === "facture" && (
            <h5 class="card-title">
              Les produits associés à la facture
              <span> {params.refDocument} </span>
            </h5>
          )}

          {params.type === "documentHistory" && (
            <h5 class="card-title">
              Les produits achetées associés à l'opération d'achat
              <span> {params.documentReference} </span> et le dépôt{" "}
              <span> {params.warehouseName}</span>
            </h5>
          )}
        </div>
        {documentProducts.sales && (
          <DataTableProductsSale listProduits={documentProducts.sales} refrech={refrech} setRefrech={setRefrech} />
        )}
      </section>
    </div>
  );
};
export default withLoader(ProductsBySaleDocument);
